import './individual-challenge.scss';
import { useState, useRef, useEffect, useCallback } from 'react';
import Header from '../../components/header/header';
import TabsHome from '../../components/tabs-home/tabs-home';
import { Link, useNavigate } from "react-router-dom";
import Button from '../../components/button/button';
import ModalSearchUser from '../../components/modal-search-user/modal-search-user';
import EmptyState from '../../components/empty-state/empty-state';
import IndividualChallengeService from '../../services/individual-challenge-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION, ASSETS, CAMPAIGN_STATUS } from '../../constants';
import ModalPausedGame from '../../components/modal-paused-game/modal-paused-game';
import ModalWithoutUsers from '../../components/modal-without-users/modal-without-users';
import ModalChallengeStatus from '../../components/modal-challenge-status/modal-challenge-status';import TranslateService from '../../services/translate-service';
import UtilsService from '../../services/utils-service';
import Avatar from  '../../components/avatar/avatar';
import CampaignTabs from  '../../components/campaign-tabs/campaign-tabs';
import ModalChallengeRecords from  '../../components/modal-challenge-records/modal-challenge-records';
import ModalTemplate from  '../../components/modal-template/modal-template';


import EventBusService from '../../services/EventBusService'
import { NEW_CAMPAIGN_EVENT } from '../../constants';

export default function IndividualChallenge() {

    const navigate = useNavigate();

    const firstUpdate = useRef(true);

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));

    const [isOpenSearchModal, setIsOpenSearchModal] = useState(false);
    const [showModalPausedGame, setModalPausedGame] = useState(false);
    const [showModalWithoutUsers, setShowModalWithoutUsers] = useState(false);
    const [showModalChallenge, setShowModalChallenge] = useState(false);
    const [showModalChallengeRecords, setShowModalChallengeRecords] = useState(false);
    const [dataModalChallenge, setDataModalChallenge] = useState(null);

    const [leaderboard, setLeaderboard] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [yourTurn, setYourTurn] = useState([]);
    const [theirTurn, setTheirTurn] = useState([]);

    const [campaign, setCampaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));
    const [tabCampaignActive, setTabCampaignActive] = useState('campaign');

    const [showChallengeRecords, setShowChallengeRecords] = useState(false);

    const handleCampaignStatus = useCallback((event) => setCampaign(event.detail?.campaign), [])

    const existsChallengeRecords = async () => {
        const response = await IndividualChallengeService.existsChallengeRecords(session._id, team.area._id);
        setShowChallengeRecords(response.existeHistorico)
    }
    const getSuggestions = async () => {
        const response = await IndividualChallengeService.getSuggestions(session._id, team.area._id);
        setSuggestions(response)
    }
    const getYourTurn = async () => {
        const yourTurnResponse = await IndividualChallengeService.getYourTurn(session._id, team.area._id);
        const firstChallengeResponse = await IndividualChallengeService.getFirstChallenge(session._id, team.area._id);

        setYourTurn(firstChallengeResponse.concat(yourTurnResponse))
    }
    const getTheirTurn = async () => {
        const response = await IndividualChallengeService.getTheirTurn(session._id, team.area._id);

        setTheirTurn(response)
    }
    const getLeaderboard = useCallback(async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await IndividualChallengeService.getLeaderboard(session._id, team.area._id, campaignID);
        
        setLeaderboard(response);
    }, [ campaign, session._id, tabCampaignActive, team.area._id])

    const canPlay = async (callback) => {
        const response = await IndividualChallengeService.canPlay(team.area._id);
        if (response.jugar) {
            callback();
        } else {
            setModalPausedGame(true);
        }
    }

    const randomChallenge = async () => {
        try {
            const response = await IndividualChallengeService.randomChallenge(session._id, team.area._id);
            navigate(`/individual-challenge/round`, { state: { round: response } });
        } catch (error) {
            setShowModalWithoutUsers(true);
        }
    }

    const goToChallenge = async (opponent) => {
        const response = await IndividualChallengeService.challenge(session._id, team.area._id, opponent);
        navigate(`/individual-challenge/round`, { state: { round: response } });
    }

    const myTurn = async (challenge, opponent) => {
        const response = await IndividualChallengeService.myTurn(challenge, opponent);

        navigate(`/individual-challenge/round`, { state: { round: response } });
    }

    const formatMyExpiration = (data) => {
        let text = TranslateService.get('indivualChall.challenges.yourTurn.expiration');

        text = text.replace('{expiration}', data.restante);
        text = text.replace('{unit}', TranslateService.get(`indivualChall.challenges.yourTurn.expiration.unit.${data.unitLanguage.toLowerCase()}`));

        return text;
    }
    const formatRound = ({rondaActual, totalRondas}) => {
        let text = TranslateService.get('indivualChall.statusChallenge.round');
        
        text = text.replace('{current}', rondaActual);
        text = text.replace('{total}', totalRondas);

        return text;
    }

    const handleModalChallengeStatus = async (challenge) => {
        const response = await IndividualChallengeService.getChallengeStatus(session._id, team.area._id, challenge.oponente._id, challenge.desafio);
        
        setDataModalChallenge({...response, status: 'ongoing'});
        setShowModalChallenge(true);
    }

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;

            getSuggestions();
            getYourTurn();
            getTheirTurn();
            existsChallengeRecords();
            // getLeaderboard();
            return;
        }
    });
    
    useEffect(() => getLeaderboard() , [tabCampaignActive, getLeaderboard]);

    useEffect(() => {
        EventBusService.on(NEW_CAMPAIGN_EVENT, handleCampaignStatus)

        return () => {
            EventBusService.remove(NEW_CAMPAIGN_EVENT, handleCampaignStatus)
        }
    }, [handleCampaignStatus])

    useEffect(() => {
        setTabCampaignActive(campaign ? 'campaign': 'global')
    }, [campaign]);

    return (
        <>
            <ModalSearchUser isOpen={isOpenSearchModal} onClose={() => setIsOpenSearchModal(false)} onChallenge={ (opponent) => canPlay(() => goToChallenge(opponent) ) } />
            <ModalPausedGame  isOpen={showModalPausedGame} onClose={() => setModalPausedGame(false)} />
            <ModalWithoutUsers  isOpen={showModalWithoutUsers} onClose={() => setShowModalWithoutUsers(false)} />
            <ModalChallengeStatus isOpen={showModalChallenge} data={dataModalChallenge} onClose={() => setShowModalChallenge(false)} />

            <ModalTemplate isOpen={showModalChallengeRecords} className="modal-challenge-records">
                {showModalChallengeRecords && <ModalChallengeRecords onClose={() => setShowModalChallengeRecords(false)}  /> }
            </ModalTemplate>
            
            <div className={ campaign ? ' bg-individual-challenge-campaign' : ' bg-individual-challenge'} >
                <Header />

                <div className='bg-individual-challenge-waves pt-7 pb-40'>
                    <div className='container  mx-auto px-4'>
                        <TabsHome />

                        <div className='text-center mt-12'>
                            <p className='font-family-montserrat uppercase  text-white' dangerouslySetInnerHTML={{__html: TranslateService.get('indivualChall.header')}}></p>
                            <h1 className='heading-h1 !text-white mt-2 '>{TranslateService.get('indivualChall.title')}</h1>

                            <div className='flex justify-center mt-8'>
                                <div onClick={() => setIsOpenSearchModal(true)} className='cursor-pointer font-family-montserrat !font-bold  uppercase text-white text-[16px] py-6 px-8 rounded-[8px] bg-search-btn shadow-[0_8px_16px_8px_rgba(3,3,3,0.04)] mr-5'>
                                    <p className='mb-3'>🔍</p>
                                    <p>{TranslateService.get('indivualChall.btn.search')}</p>
                                </div>

                                <div onClick={() => canPlay(randomChallenge)} className='cursor-pointer font-family-montserrat  !font-bold uppercase text-white text-[16px] py-6 px-8 rounded-[8px] bg-random-btn shadow-[0_8px_16px_8px_rgba(3,3,3,0.04)]'>
                                    <p className='mb-3'>🔮</p>
                                    <p>{TranslateService.get('indivualChall.btn.random')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                

            </div>

            <div className='container  mx-auto px-4 mt-[-100px] mb-[50px] individual-challenge'>
                <div className='grid gap-[16px] grid-cols-12'>
                    <div className='col-span-8'>
                        <div className='card mb-[16px]'>

                            <div className='flex items-center separator-bottom pb-5'>
                                <div className='heading-h6 uppercase grow  '>
                                    💫 {TranslateService.get('indivualChall.suggestions.title')}
                                </div>
                            </div>
                            <div className='flex items-center justify-between mt-[10px] suggestions'>
                                {!suggestions.length && 
                                    <div className='grow'>
                                        <EmptyState title={TranslateService.get('emptyState.generic.title')} description={TranslateService.get('emptyState.generic.description')} />
                                    </div>
                                }

                                {suggestions.map(player => (
                                    <div className='suggestions-card' key={player._id}>
                                        <Avatar className='mx-auto clean !w-[40px] !h-[40px]' image={ `${ASSETS.AVATAR_PLAYER}${player.avatar}` }/>
                                        <p className='heading-h6 suggestion-name'>{player.nombre} {player.apellidoPaterno}</p>
                                        <p className='text-secundary'>{player.score} pts</p>
                                        <p className='font-family-montserrat !font-bold text-[12px] text-link-active underline cursor-pointer uppercase' onClick={() => canPlay(() => goToChallenge(player._id) )}>{TranslateService.get('indivualChall.suggestions.link')}</p>
                                    </div>
                                ))}

                            </div>
                        </div>

                        <div className='card'>

                            <div className='flex items-center separator-bottom pb-5'>

                                <div className='heading-h6 uppercase grow  '>
                                    🌋 {TranslateService.get('indivualChall.challenges.title')}
                                </div>
                                {showChallengeRecords && 
                                    <div className=''>
                                        <Link to="/" onClick={() => setShowModalChallengeRecords(true)} className='link font-family-montserrat uppercase !font-bold'>{TranslateService.get('indivualChall.challenges.records')}</Link>
                                    </div>
                                }
                                

                            </div>

                            {!yourTurn.length && !theirTurn.length && 
                                <div className='mt-4'>
                                    <EmptyState title={TranslateService.get('emptyState.generic.title')} description={TranslateService.get('emptyState.generic.description')} />
                                </div>
                            }


                            {yourTurn.length > 0 &&  <h1 className='heading-h6 !text-heading-card uppercase pt-4'>{TranslateService.get('indivualChall.challenges.yourTurn')}</h1> }
                            {yourTurn.map(challenge => (
                                <div className="grid grid-cols-7 gap-4 items-center	py-[24px] px-[4px] " key={challenge.desafio}>
                                    <div className='flex items-center grow col-span-2'>
                                        <Avatar className='mx-auto clean !w-[48px] !h-[48px]' image={ `${ASSETS.AVATAR_PLAYER}${challenge.oponente.avatar}` }/>
                                        <div className='ml-3 grow'>
                                            <p className=''>{challenge.oponente.nombre} {challenge.oponente.apellidoPaterno}</p>
                                            <div className='w-fit text-label-light-default bg-label-light-bg rounded-[100px]  px-[6px] text-[10px] font-semibold uppercase'>{TranslateService.get('indivualChall.challenges.yourTurn.label')}...</div>
                                        </div>
                                    </div>
                                    <div className='text-center separator-left separator-right col-span-2'>
                                        {challenge.reto && <h1 className='font-family-montserrat text-[20px] !font-bold'>{challenge.reto.oponente} : {challenge.reto.yo}</h1>}
                                        {!challenge.reto && <h1 className='font-family-montserrat text-[20px] !font-bold'>0 : 0</h1>}

                                        <p className='text-secundary mb-[8px]'>{formatRound(challenge)}</p>
                                        <p className='font-family-montserrat !font-bold text-[10px] text-link-active underline cursor-pointer uppercase' onClick={() => handleModalChallengeStatus(challenge)}>{TranslateService.get('indivualChall.challenges.btn.details')}</p>
                                    </div>
                                    <div className='col-span-3'>
                                        <div className='flex items-center'>
                                            <div>
                                                <p>You</p>

                                                <div className='w-fit text-label-primary-default bg-label-primary-bg rounded-[100px]  px-[6px] text-[10px] font-semibold uppercase'>{formatMyExpiration(challenge.tiempoRestante)}</div>
                                            </div>
                                            <div className='ml-auto'>
                                                <Button className="small " onClick={() => myTurn(challenge.desafio, challenge.oponente._id)}>{TranslateService.get('indivualChall.challenges.btn.play')}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}


                            {theirTurn.length > 0 &&  <h1 className='heading-h6 !text-heading-card uppercase pt-4'>{TranslateService.get('indivualChall.challenges.theirTurn')}</h1> }
                            {theirTurn.map(challenge => (
                                <div className="grid grid-cols-7 gap-4 items-center	py-[24px] px-[4px] " key={challenge.desafio}>
                                    <div className='flex items-center grow col-span-2'>
                                        <div className='avatar-custom'>
                                            <Avatar className='mx-auto clean !w-[44px] !h-[44px]' image={ `${ASSETS.AVATAR_PLAYER}${challenge.oponente.avatar}` }/>
                                            <svg>
                                                <circle r="25" cx="28" cy="28" strokeDashoffset={156-((challenge.minutosRestantes*156)/100) } ></circle>
                                                <defs>
                                                    <linearGradient id="header-shape-gradient" x2="0.35" y2="1">
                                                        <stop offset="0%" stopColor="#ffcd05" />
                                                        <stop offset="30%" stopColor="#ffcd05" />
                                                        <stop offset="100%" stopColor="#fa951f" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                        
                                        <div className='ml-3'>
                                            <p className=''>{challenge.oponente.nombre} {challenge.oponente.apellidoPaterno}</p>
                                            <div className='w-fit text-label-light-default bg-label-light-bg rounded-[100px]  px-[6px] text-[10px] font-semibold uppercase'>
                                                {formatMyExpiration(challenge.tiempoRestante)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-center separator-left separator-right col-span-2'>
                                        <h1 className='font-family-montserrat text-[20px] !font-bold'>{challenge.reto.oponente} : {challenge.reto.yo}</h1>
                                        <p className='text-secundary mb-[8px]'>{formatRound(challenge)}</p>
                                        <p className='font-family-montserrat !font-bold text-[10px] text-link-active underline cursor-pointer uppercase' onClick={() => handleModalChallengeStatus(challenge)}>{TranslateService.get('indivualChall.challenges.btn.details')}</p>
                                    </div>
                                    <div className='col-span-3'>
                                        <div className='flex items-center'>
                                            <div>
                                                <p>You</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='col-span-4'>
                        <div className='card !p-0'>
                            <div className='flex items-center separator-bottom p-5'>
                                <div className='heading-h6 uppercase  grow'>
                                    🏆 {TranslateService.get('indivualChall.challenges.leaderboard')}
                                </div>

                                <CampaignTabs active={tabCampaignActive} setTab={(tab) => setTabCampaignActive(tab)}/>
                            </div>

                            {leaderboard.filter( player => player.posicion <= 10 || player._id === session._id).map((player) => (
                                <div className={ 'flex items-center p-[24px] ' + (player._id === session._id ? 'leaderboard-rank': '') } key={player._id} >
                                    <div className={'mr-[24px]  text-center w-[56px] font-family-montserrat ' + (player.posicion <= 3 ? 'text-[32px]' : '')}>
                                        {player.posicion === 1 && '🥇'}
                                        {player.posicion === 2 && '🥈'}
                                        {player.posicion === 3 && '🥉'}
                                        {player.posicion > 3 && `${player.posicion}`}

                                    </div>
                                    <div className='flex items-center grow'>
                                        <Avatar className='mx-auto clean !w-[40px] !h-[40px]' image={ `${ASSETS.AVATAR_PLAYER}${player.avatar}` }/>
                                        <div className='ml-[16px] grow'>
                                            <p className='heading-h6'>{UtilsService.capitalize(player.nombre, player.apellidoPaterno)} {player._id === session._id ? '(You)' : ''}</p>
                                            <p className='text-secundary'>{UtilsService.format(player.puntos)} pts</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
